package dev.jfronny.zerointerest.data

enum class TrustState {
    UNTRUSTED,
    TRUSTED,
    REJECTED,
}
